import {Component} from '@angular/core';
import {MainComponent} from '../main/main.component';
import {DocumentationTableComponent} from './documentation-table/documentation-table.component';
import {FaqComponent} from './faq/faq.component';

@Component({
  selector: 'em-documentation-page',
  templateUrl: './documentation-page.component.html',
  imports: [MainComponent, DocumentationTableComponent, FaqComponent],
})
export class DocumentationPageComponent {}
